import { render, staticRenderFns } from "./law-cases-stats.vue?vue&type=template&id=e9bfcd6c"
import script from "./law-cases-stats.vue?vue&type=script&lang=js"
export * from "./law-cases-stats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports